module.exports = __webpack_public_path__ + "static/img/punball_small_1.ca70bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ko/punball_small_1.jpg
// module id = XGfd
// module chunks = 0